// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-677a3bd0] .el-menu-item.is-active{background:#dedede!important;color:#444!important}", ""]);
// Exports
module.exports = exports;
